import React, { useState } from "react";
import Marketing1 from "../../../../images/LandingPageImage/marketing_1x.webp";
import Healthcare from "../../../../images/LandingPageImage/healthcare_1x.webp";
import Travel from "../../../../images/LandingPageImage/travel_1x.webp";
import Realestate from "../../../../images/LandingPageImage/realestate_1x.webp";
import Logistics from "../../../../images/LandingPageImage/logistics_1x.webp";
import Ecomm from "../../../../images/LandingPageImage/e_commerce_1x.webp";
import Education from "../../../../images/LandingPageImage/education_1x.webp";
import "../designcss/Industries.css";

const getText = (title, subtitle, points) => (
  <div className="industry-box">
    <h4 className="industry-title">{title}</h4>

    <p className="industry-subtitle">{subtitle}</p>

    <ul className="industry-points">
      {points.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);

const categories = [
  {
    id: 1,
    name: "Marketing",
    img: Marketing1,
    text: getText(
      "Marketing",
      "Simplify agency workflows with WhatsApp chatbots. Manage campaigns, client conversations, and follow-ups easily with intelligent WhatsApp chatbots built for modern agencies.",
      [
        "Automate customer follow-ups",
        "Send timely updates at scale",
        "Boost conversions with smart WhatsApp notifications",
      ]
    ),
  },
  {
    id: 2,
    name: "Healthcare",
    img: Healthcare,
    text: getText(
      "Healthcare",
      "Improve patient communication with real-time WhatsApp alerts. Enhance patient experience through automated WhatsApp communication.",
      [
        "Send appointment reminders automatically",
        "Enable 24/7 patient support with chatbots",
        "Reduce waiting time with instant responses",
      ]
    ),
  },
  {
    id: 3,
    name: "Travel",
    img: Travel,
    text: getText(
      "Travel",
      "Keep travellers informed with instant WhatsApp updates. Share real-time travel information through WhatsApp notifications.",
      [
        "Send booking confirmations instantly",
        "Provide live flight and schedule updates",
        "Automate travel itinerary delivery",
        "WhatsApp automation helps travel brands build trust and reduce customer queries",
      ]
    ),
  },
  {
    id: 4,
    name: "Real Estate",
    img: Realestate,
    text: getText(
      "Real Estate",
      "Close property deals faster with WhatsApp automation. Connect with buyers instantly and manage property communication efficiently.",
      [
        "Automate property inquiries and follow-ups",
        "Share listings and ads in real time",
        "Respond instantly to buyer requests",
        "Capture and qualify high-intent property leads",
      ]
    ),
  },
  {
    id: 5,
    name: "Education",
    img: Education,
    text: getText(
      "Education",
      "Transform student communication with WhatsApp automation for institutions and educators.",
      [
        "Send admission and course updates",
        "Automate student inquiries",
        "Share exam schedules instantly",
      ]
    ),
  },
  {
    id: 6,
    name: "Logistics",
    img: Logistics,
    text: getText(
      "Logistics",
      "Enable real-time shipment communication on WhatsApp. Improve transparency and customer confidence with automated logistics updates.",
      [
        "Share live shipment tracking",
        "Send delivery status notifications",
        "Auto-reply to order-related queries",
      ]
    ),
  },
  {
    id: 7,
    name: "E-Commerce",
    img: Ecomm,
    text: getText(
      "E-Commerce",
      "Drive repeat purchases with WhatsApp automation. Turn first-time buyers into loyal customers using personalised WhatsApp campaigns.",
      [
        "Send instant order and delivery updates",
        "Recover abandoned carts automatically",
        "Increase repeat sales with targeted bulk WhatsApp messages",
      ]
    ),
  },
];


const IndustriesAll = () => {
  const [active, setActive] = useState(categories[0]);

  return (
    <div className="industry-container">
      <div className="betterquicker">
        <h3>
          A Smart way for logistics brand to use bulk WhatsApp <span> messaging responsibly and effectively
          </span>
        </h3>
      </div>
      {/* TOP BUTTONS */}
      <div className="industry-buttons">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`industry-btn ${active.id === cat.id ? "active" : ""}`}
            onClick={() => setActive(cat)}
          >
            {cat.name}
          </button>
        ))}

      </div>

      {/* CONTENT AREA */}
      <div className="industry-content">
        <div className="industry-text">{active.text}</div>
        <div className="industry-image">
          <img src={active.img} alt={active.name} />
        </div>
      </div>
    </div>
  );
};

export default IndustriesAll;
